// removed by extract-text-webpack-plugin
module.exports = {"header":"_3LQ64 _37W4X _2AJrG _1PyuO _37W4X _2AJrG","list":"bQKSq OPZ6L xdpBZ","list-wrapper":"_2Ydkd OPZ6L xdpBZ","empty":"_1JV60 _38618 _3Dqep _1X7sA _1b0Gt","item":"_11yCM _2Hk-A _38618 _3Dqep _18-EI","itemBody":"_3wIie _2kZNz","itemTitle":"_2nDq4 _3TD8R","itemName":"_1Q1yt _3K4no CO6xt","itemSubtitle":"_2GXvv","itemSubtitleBold":"_3q1Jt","open":"iQVSf","tagIcon":"LUqOT"};


//////////////////
// WEBPACK FOOTER
// ./questions/components/List.css
// module id = 748
// module chunks = 3